// src/firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, getFirestore } from 'firebase/firestore';

// Replace with your Firebase config from Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyAOP30qCrzNDBAub562C3qDhFcW0dKsmOY",
    authDomain: "avenir-website-5c132.firebaseapp.com",
    projectId: "avenir-website-5c132",
    storageBucket: "avenir-website-5c132.firebasestorage.app",
    messagingSenderId: "478307590688",
    appId: "1:478307590688:web:f83550c0e640a94c755245",
    measurementId: "G-3YT06673B7"
};

// Fast Refresh re-evaluates this module without tearing down the previous
// Firebase instances, and both initializeApp and initializeFirestore throw
// when they find one already running. An exception here breaks the whole
// module graph, which surfaces downstream as confusing TDZ errors such as
// "Cannot access 'AuthProvider' before initialization" — so reuse whatever
// already exists instead of trying to start it twice.
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);

// getDocs() hangs forever — no error, no rejection — when Firestore's
// WebChannel stream opens but never delivers, which happens behind proxies,
// VPNs and some corporate networks. Long polling avoids that handshake and
// completes reads normally.
function startFirestore() {
  try {
    return initializeFirestore(app, { experimentalForceLongPolling: true });
  } catch (err) {
    // Already started (hot reload): its settings are locked, so take it as is.
    return getFirestore(app);
  }
}

export const db = startFirestore();
export default app;
